import React from "react";
import Stopwatch from "./components/Stopwatch";

function App() {
  return <Stopwatch />;
}

export default App;